<template>
	<div class="m-drawer" :class="{ open: isOpen }" @click.self="$emit('close')">
		<div class="m-sheet" :class="{ 'm-sheet-product': showProduct }">
			<transition name="fade" mode="out-in">
				<MenuProduct v-if="showProduct" class="sheet-content-product" key="product" :tab="currentTab"
					:section="currentSection" :items="currentCategoryItems" @back="closeProduct"
					@close="$emit('close')" />
				<MenuSec v-else-if="showSec" class="sheet-content" key="sec" :secMenu="secMenu"
					:items="currentInfoItems" @back="closeSec" @close="$emit('close')" />
				<div v-else key="main" class="sheet-content">
					<div class="m-sheet-top">
						<button class="icon-btn" @click="$emit('search')">
							<img src="@/assets/icon/search_black.png" alt="search" />
						</button>
						<button class="icon-btn" @click="$emit('close')">×</button>
					</div>

					<div class="m-tabs">
						<span class="tab"
							:class="{ active: activeTab === 'collection', inactive: activeTab !== 'collection' }"
							@click="setTab('collection')">Collection</span>
						<span class="tab" :class="{ active: activeTab === 'info', inactive: activeTab !== 'info' }"
							@click="setTab('info')">Info</span>
						<span class="tab"
							:class="{ active: activeTab === 'projects', inactive: activeTab !== 'projects' }"
							@click="setTab('projects')">HAHA!</span>
					</div>

					<transition name="fade" mode="out-in">
						<!-- Collection 标签内容 -->
						<div v-if="activeTab === 'collection'" key="collection" class="tab-content">
							<div v-for="block in collectionBlocks" :key="block.title" class="m-section">
								<div class="m-title" @click="goToBy('collection', block.sectionKey)">
									{{ block.title }}
								</div>
							</div>
							<div class="m-view-all" @click="goToAllCollection">VIEW ALL</div>
						</div>

						<!-- Info 标签内容 -->
						<div v-else-if="activeTab === 'info'" key="info" class="tab-content">
							<div v-for="block in infoBlocks" :key="block.title" class="m-section">
								<div class="m-title" @click="openSecMenu(block.sectionKey, block.title)">
									{{ block.title }}
								</div>
							</div>
						</div>

						<!-- Projects 标签内容 -->
						<div v-else key="projects" class="tab-content">
							<div class="m-section">
								<div class="m-title" @click="goToProjects">denHolm United</div>
							</div>
						</div>
					</transition>

					<div class="m-bottom-links">
						<a class="m-link" @click="goToLogin">Login</a>
						<a class="m-link" @click="openSubscribe">Subscribe</a>
					</div>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
	import {
		getCategoryList
	} from '@/api/product'
	import {
		showMessage
	} from '@/config/message'
	import MenuProduct from './MenuProduct.vue'
	import MenuSec from './MenuSec.vue'

	import aboutImg from '@/assets/_DSC0544 2 3.jpg'
	import founderImg from '@/assets/_DSC0544 2 4.jpg'
	import contactImg from '@/assets/_DSC0544 2 4.png'

	export default {
		name: 'MobileMenu',
		props: {
			isOpen: {
				type: Boolean,
				default: false
			}
		},
		components: {
			MenuProduct,
			MenuSec
		},
		data() {
			return {
				activeTab: 'collection',
				showProduct: false,
				showSec: false,
				currentTab: '',
				currentSection: '',
				secMenu: {
					title: '',
					thirdTitel: ''
				},
				collectionBlocks: [], // 一级分类列表（如 TABLE, SEATING, ACCESSORIES）
				collectionMap: {}, // 二级分类映射：{ sectionKey: [ { label, CategoryID, ... } ] }
				infoBlocks: [ // Info 静态块（可后续改为接口）
					{
						title: 'ABOUT',
						sectionKey: 'about',
						items: []
					},
					{
						title: 'CONTACT',
						sectionKey: 'contact',
						items: []
					}
				],

				infoMap: {
					about: [{
							label: 'About Us',
							route: 'About',
							image: aboutImg
						},
						{
							label: 'Founder',
							route: 'Founder',
							image: founderImg
						}
					],
					contact: [{
						label: 'Contact',
						route: 'Contact',
						image: contactImg
					}]
				},
				// 默认 Collection 一级分类（参考电脑端）
				defaultCollectionBlocks: [{
						title: 'TABLE',
						sectionKey: 'table'
					},
					{
						title: 'SEATING',
						sectionKey: 'seating'
					},
					{
						title: 'ACCESSORIES',
						sectionKey: 'accessories'
					}
				],
				// 默认二级分类映射
				defaultCollectionMap: {
					table: [{
							label: 'Entry Table',
							CategoryID: 1,
							image: require('@/assets/Group 1-1.png')
						},
						{
							label: 'Console Table',
							CategoryID: 2,
							image: require('@/assets/Group 1-2.png')
						},
						{
							label: 'Coffee Table',
							CategoryID: 3,
							image: require('@/assets/Group 1-3.png')
						},
						{
							label: 'Side Table',
							CategoryID: 4,
							image: require('@/assets/Group 1-4.png')
						}
					],
					seating: [{
							label: 'Chair',
							CategoryID: 5,
							image: require('@/assets/_DSC0544 2 3.png')
						},
						{
							label: 'Stool',
							CategoryID: 6,
							image: require('@/assets/_DSC0544 2 3-1.png')
						}
					],
					accessories: [{
							label: 'Planter',
							CategoryID: 7,
							image: require('@/assets/_DSC0544 2 4.jpg')
						},
						{
							label: 'Lighting',
							CategoryID: 8,
							image: require('@/assets/_DSC0544 2 3.png')
						},
						{
							label: 'Mirror',
							CategoryID: 9,
							image: require('@/assets/_DSC0544 2 3-1.png')
						},
						{
							label: 'Hardware',
							CategoryID: 10,
							image: require('@/assets/_DSC0544 2 4.jpg')
						},
						{
							label: 'Decor',
							CategoryID: 11,
							image: require('@/assets/_DSC0544 2 3.png')
						}
					]
				},
				// 静态 Info 数据（若需要也可默认）
				defaultInfoMap: {
					about: [{
							label: 'About Us',
							route: 'About',
							image: require('@/assets/_DSC0544 2 3.jpg')
						},
						{
							label: 'Founder',
							route: 'Founder',
							image: require('@/assets/_DSC0544 2 4.jpg')
						}
					],
					contact: [{
						label: 'Contact',
						route: 'Contact',
						image: require('@/assets/_DSC0544 2 4.png')
					}]
				}
			}
		},
		computed: {
			// 当前选中的 Collection 分类下的子项
			currentCategoryItems() {

				return this.collectionMap[this.currentSection] || []
			},
			// 当前选中的 Info 分类下的子项
			currentInfoItems() {

				return this.infoMap[this.secMenu.thirdTitel.toLowerCase()] || []
			}
		},
		watch: {
			isOpen(val) {
				if (val) {
					this.fetchCollectionData()
				} else {
					// 关闭时重置状态
					this.showProduct = false
					this.showSec = false
					this.currentSection = ''
				}
			}
		},
		created() {
			this.collectionBlocks = this.defaultCollectionBlocks
			this.collectionMap = this.defaultCollectionMap
			this.infoMap = this.defaultInfoMap // 如果 infoMap 也用默认
		},
		mounted() {
			if (this.isOpen) {
				this.fetchCollectionData()
			}
		},
		methods: {
			setTab(tab) {
				this.activeTab = tab
			},
			// 获取分类数据
			// async fetchCollectionData() {
			//   try {
			//     const response = await getCategoryList()
			//     const list = Array.isArray(response) ? response : (response.result || [])
			//     if (!list.length) return

			//     // 构建 collectionBlocks 和 collectionMap
			//     const blocks = []
			//     const map = {}
			//     list.forEach(block => {
			//       const title = block.CategoryName
			//       // 将标题转换为 sectionKey（小写，用于匹配）
			//       const sectionKey = this.normalizeKey(title)
			//       blocks.push({ title, sectionKey })

			//       // 子项处理
			//       const items = (block.Items || []).map(item => ({
			//         key: this.normalizeKey(item.CategoryName),
			//         label: item.CategoryName,
			//         CategoryID: item.CategoryID,
			//         image: item.CategoryImage
			//       }))
			//       map[sectionKey] = items
			//     })
			//     this.collectionBlocks = blocks
			//     this.collectionMap = map
			//   } catch (error) {
			//     console.error('Failed to load collection categories:', error)
			//     showMessage('Failed to load menu', 'error')
			//   }
			// },

			async fetchCollectionData() {
				// 1. 先使用默认数据，确保菜单立即可见
				if (this.collectionBlocks.length === 0) {
					this.collectionBlocks = this.defaultCollectionBlocks
					this.collectionMap = this.defaultCollectionMap
				}

				try {
					const response = await getCategoryList()
					const list = Array.isArray(response) ? response : (response.result || [])
					if (!list.length) return

					const blocks = []
					const map = {}
					list.forEach(block => {
						const title = block.CategoryName
						const sectionKey = this.normalizeKey(title)
						blocks.push({
							title,
							sectionKey
						})
						const items = (block.Items || []).map(item => ({
							key: this.normalizeKey(item.CategoryName),
							label: item.CategoryName,
							CategoryID: item.CategoryID,
							image: item.CategoryImage
						}))
						map[sectionKey] = items
					})
					// 更新为接口数据
					this.collectionBlocks = blocks
					this.collectionMap = map
				} catch (error) {
					console.error('Failed to load collection categories:', error)
					// 接口失败时保持默认数据，不覆盖
				}
			},
			// 规范化键名
			normalizeKey(str) {
				return String(str || '')
					.toLowerCase()
					.replace(/[^a-z0-9]+/g, '-')
					.replace(/^-|-$/g, '')
			},
			// 点击 Collection 一级分类
			goToBy(tab, sectionKey) {
				this.currentTab = tab
				this.currentSection = sectionKey
				this.showProduct = true
			},
			// 点击 Info 一级分类
			openSecMenu(sectionKey, title) {
				this.secMenu = {
					title,
					thirdTitel: sectionKey
				}
				this.showSec = true
			},
			// 关闭次级菜单
			closeSec() {
				this.showSec = false
			},
			closeProduct() {
				this.showProduct = false
			},
			// 查看全部 Collection
			goToAllCollection() {

				this.$router.push({
					name: 'ProductIndex',
					query: {
						CategoryID: 0
					}
				})
				// this.$router.push('/m/product?CategoryID=0')
				this.$emit('close')
			},
			// 跳转到 Projects
			goToProjects() {
				// this.$router.push({ name: 'Projects' })
				// this.$emit('close')
				window.open('https://www.denholm-united.com', '_blank')
				this.closeMenu()
				return
			},
			// 跳转登录页
			goToLogin() {
				this.$router.push('/m/user-info')
				this.$emit('close')
			},
			// 打开订阅弹窗（需配合全局事件或父组件处理）
			openSubscribe() {
				this.$emit('close')
				// 触发全局事件打开订阅弹窗（需在 App.vue 或父组件监听）
				window.dispatchEvent(new CustomEvent('open-email-popup'))
			}
		}
	}
</script>

<style scoped>
	.m-drawer {
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		height: 100vh;
		background: rgba(0, 0, 0, 0);
		z-index: 50;
		pointer-events: none;
		transition: background-color 0.3s ease;
	}

	.m-drawer.open {
		background: rgba(0, 0, 0, 0.35);
		pointer-events: auto;
	}

	.m-sheet {
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		background: #fff;
		transform: translateY(100%);
		transition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
		height: 78vh !important;
		border-top: 2rem solid #000;
		overflow: hidden;
		display: flex;
		flex-direction: column;
	}
	
	.m-sheet.m-sheet-product {
		display: flex;
		flex-direction: column;
		overflow: hidden;
		min-height: 0; /* 添加这一行！关键 */
	}
	
	.sheet-content-product {
		padding: 0;
		flex: 1;
		min-height: 0; /* 添加这一行！关键 */
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}
	
	/* 非 product 状态的 sheet-content 也需要调整 */
	.sheet-content {
		padding: 29rem;
		flex: 1;
		min-height: 0;
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}
	
	.tab-content {
		flex: 1;
		min-height: 0;
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;
	}

	 
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.3s ease;
	}

	.fade-enter,
	.fade-leave-to {
		opacity: 0;
	}

	.m-sheet.m-sheet-product {
		/* padding-top: 0; */
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}

	.open .m-sheet {
		transform: translateY(0%);
	}

	.m-sheet-top {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 62rem;
	}

	.icon-btn {
		background: none;
		border: none;
		padding: 0;
		width: 28rem;
		height: 28rem;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 20rem;
		color: #000;
	}

	.icon-btn img {
		width: 18rem;
		height: 18rem;
	}

	.m-tabs {
		display: flex;
		justify-content: space-between;
		gap: 10rem;
		align-items: center;
		padding: 0 0 90rem;
	}

	.tab {
		font-size: 15rem;
		font-weight: 400;
		font-family: 'BespokeSerif', serif;
	}

	.tab.active {
		color: #000;
	}

	.tab.inactive {
		color: #bbb;
	}

	.m-section {
		padding-top: 15rem;
	}

	.m-large {
		font-size: 16rem;
		font-weight: 600;
	}

	.m-title {
		font-size: 15rem;
		font-weight: 500;
		font-family: 'Apercu-Medium', sans-serif !important;
	}

	.m-list {
		list-style: none;
		padding: 0;
		margin: 0;
		display: grid;
		gap: 10rem;
	}

	.m-item {
		font-size: 14rem;
		color: #000;
	}

	.m-item.m-link {
		text-decoration: underline;
	}

	.m-view-all {
		padding: 68rem 0;
		font-size: 15rem;
		font-weight: 500;
		font-family: 'Apercu-Medium', sans-serif !important;
	}

	.m-bottom-links {
		padding-bottom: 10rem;
		display: grid;
		gap: 2rem;
		position: fixed;
		bottom: 29rem;
	}

	.m-link {
		color: #000;
		text-decoration: none;
		font-size: 15rem;
		font-weight: 400;
		font-family: 'BespokeSerif', serif;
	}

	.tab-content {
		height: 400px;
		overflow-y: auto;
		/* overflow: hidden; */
		-webkit-overflow-scrolling: touch;
		/* 提升移动端滚动流畅度 */
	}
</style>